import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "multi-input-row" };
const _hoisted_2 = { class: "multi-input-row" };
import { computed, watch, ref, nextTick, } from 'vue';
import { numberToFormatted, formattedToNumber, } from '@/utils';
import { validationLimitingValue } from '@/constants';
import { errorCode } from '@/error';
import { isRequiredZeroAvailable, lessThanMaxAmount, } from '@/form/form-rules';
import { i18n } from '@/locales';
import InputRow from '@/components/Form/InputRow.vue';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import vuexStore from '@/vuex-store';
const lc = 'views.store_management_goods_price_surcharge_infos.';
const tableLc = 'views.store_management_goods_price_surcharge_infos.table.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AddSection',
    setup(__props) {
        // 상품가 할증 추가 form
        const isSubmitDisabled = ref(false);
        const formRef = ref(null);
        const formValid = ref(false);
        const formData = ref({});
        const formRules = ref({});
        const isDuplicatedError = ref(false);
        const { STORE_ORDER_AMOUNT_MAX_LENGTH, STORE_SURCHARGE_MAX_LENGTH, STORE_SURCHARGE_RATE_MAX_LENGTH, STORE_SURCHARGE_RATE_MAX_AMOUNT, } = validationLimitingValue;
        const showSuccess = (payload) => vuexStore.dispatch(snackbarActionType.showSuccess, payload);
        const showError = (payload) => vuexStore.dispatch(snackbarActionType.showError, payload);
        const isAddSurchargeSectionOpen = computed(() => (vuexStore.state
            .storeManagement
            .storeGoodsPriceSurchargeInfos.isStoreManagementGoodsPriceSurchargeInfosAddSurchargeSectionOpen));
        const selectedStoreId = computed(() => (vuexStore.state
            .storeManagement
            .storeGoodsPriceSurchargeInfos.selectedStoreId));
        const setStoreManagementGoodsPriceSurchargeInfosAddSurchargeSectionOpen = (payload) => (vuexStore.dispatch('storeManagement/storeGoodsPriceSurchargeInfos/setStoreManagementGoodsPriceSurchargeInfosAddSurchargeSectionOpen', payload));
        const postStoreManagementGoodsPriceSurchargeInfos = (payload) => vuexStore.dispatch('storeManagement/storeGoodsPriceSurchargeInfos/postStoreManagementGoodsPriceSurchargeInfos', payload);
        /**
             * 숫자형 formData를 위한 메서드입니다.
             * formData가 1000일 시 1,000과 같은 formatted로 전환되어 노출됩니다.
             * formData는 수정 시 계속 formData에 Number로서 저장됩니다.
             * 두번째 인자 제공 시
             * 값이 없을 때 0이 아닌 null로 처리합니다.
             * 이는 formatted가 ''가 되어 0에 대한 set이 작동하지 않는 경우를 방지합니다.
             * 또한 이는 0이 formData로 전송시 문제없이 api가 작동하는 것을 방지합니다.
             * 해당 값은 blur 시 기본값 처리를 위해 필수적으로 사용됩니다.
             */
        const makeFormDataToComputed = (field, spaceToNull) => computed({
            get() {
                return numberToFormatted(formData.value[field]);
            },
            set(value) {
                if (spaceToNull && value === '') {
                    formData.value[field] = null;
                    return;
                }
                formData.value[field] = formattedToNumber(value);
            },
        });
        const formattedOrderAmountStart = makeFormDataToComputed('orderAmountStart', true);
        const formattedOrderAmountEnd = makeFormDataToComputed('orderAmountEnd', true);
        const formattedSurcharge = makeFormDataToComputed('surcharge', true);
        const formattedSurchargeRate = makeFormDataToComputed('surchargeRate', true);
        const createFormData = () => ({
            orderAmountStart: null,
            orderAmountEnd: null,
            surcharge: 0,
            surchargeRate: 0,
        });
        const createFormRules = () => ({
            orderAmountStart: computed({
                get() {
                    return [
                        (v) => {
                            isDuplicatedError.value = false;
                            return isRequiredZeroAvailable(v);
                        },
                    ];
                },
                set() { },
            }),
            orderAmountEnd: computed({
                get() {
                    return [
                        (v) => {
                            isDuplicatedError.value = false;
                            return isRequiredZeroAvailable(v);
                        },
                        (v) => formattedToNumber(v) >= formData.value.orderAmountStart,
                    ];
                },
                set() { },
            }),
            surcharge: computed({
                get() {
                    return [
                        (v) => isRequiredZeroAvailable(v),
                    ];
                },
                set() { },
            }),
            surchargeRate: computed({
                get() {
                    return [
                        (v) => isRequiredZeroAvailable(v),
                        (v) => lessThanMaxAmount(formattedToNumber(v), STORE_SURCHARGE_RATE_MAX_AMOUNT),
                    ];
                },
                set() { },
            }),
        });
        /**
             * 할증 금액 기본값 설정 메서드 (기본값 - 0)
             */
        const onBlurSurchargeField = (value) => {
            if (value) {
                return;
            }
            formData.value.surcharge = 0;
        };
        /**
             * 할증 퍼센트 기본값 설정 메서드 (기본값 - 0)
             */
        const onBlurSurchargeRateField = (value) => {
            if (value) {
                return;
            }
            formData.value.surchargeRate = 0;
        };
        const initForm = () => {
            formData.value = createFormData();
            formRules.value = {};
            formRef.value.resetValidation();
            isDuplicatedError.value = false;
        };
        const closeAddSurchargeSection = () => {
            setStoreManagementGoodsPriceSurchargeInfosAddSurchargeSectionOpen(false);
        };
        const handleClickCancelBtn = () => {
            // 다이얼로그 안의 "취소" 버튼은 인풋필드 값 상관없이 묻지 않고 추가 영역이 닫힘
            closeAddSurchargeSection();
        };
        const _onSubmit = async () => {
            const storeId = selectedStoreId.value;
            const payload = {
                storeId,
                ...formData.value,
            };
            try {
                await postStoreManagementGoodsPriceSurchargeInfos(payload);
                showSuccess({
                    message: i18n.t(`${lc}surcharge_add_success_message`),
                });
                initForm();
            }
            catch (error) {
                if (Object.keys(errorCode).includes(error.reason)) {
                    showError({
                        message: errorCode[error.reason],
                    });
                    isDuplicatedError.value = true;
                    return;
                }
                showError({
                    message: i18n.t('common.failure'),
                });
            }
        };
        const _validateForm = async () => {
            // '추가' 버튼을 누르기 전에는 유효성 검사를 진행하지 않습니다.
            formRules.value = createFormRules();
            await nextTick();
            return formRef.value.validate();
        };
        const handleSubmitForm = async () => {
            const { valid } = await _validateForm();
            if (valid) {
                // success
                return _onSubmit();
            }
            const messageList = [];
            // fail
            // case 0. 시작 범위가 종료 범위보다 큰 경우(종료 범위에 error)
            const { orderAmountStart, orderAmountEnd, } = formData.value;
            const isEndGreaterThanStart = orderAmountEnd >= orderAmountStart;
            if (!isEndGreaterThanStart) {
                messageList.push('form_rules.start_greater_than_end');
            }
            // case 1. 할증 퍼센트가 99.99%를 초과할 경우
            const { surchargeRate } = formData.value;
            const isLessThanMaxAmount = lessThanMaxAmount(surchargeRate, STORE_SURCHARGE_RATE_MAX_AMOUNT);
            if (!isLessThanMaxAmount) {
                messageList.push(i18n.t(`${lc}surcharge_rate_greater_than_limit`, {
                    max: '99.9',
                }));
            }
            // case 2. 빈값의 경우 "필수 입력 정보를 확인해 주세요."
            const isSomeValueEmpty = formRef.value.items.some(({ id }) => formRef.value.$el.querySelector(`#${id}`).value === '');
            if (isSomeValueEmpty) {
                messageList.push(i18n.t('common.form_validation_error'));
            }
            return showError({
                message: messageList,
            });
        };
        watch(() => isAddSurchargeSectionOpen.value, (isOpen) => {
            if (isOpen) {
                initForm();
            }
        });
        return (_ctx, _cache) => {
            const _component_v_text_field = _resolveComponent("v-text-field");
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_card_actions = _resolveComponent("v-card-actions");
            const _component_v_form = _resolveComponent("v-form");
            const _directive_btn_style = _resolveDirective("btn-style");
            return _withDirectives((_openBlock(), _createBlock(_component_v_form, {
                ref_key: "formRef",
                ref: formRef,
                modelValue: formValid.value,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((formValid).value = $event)),
                class: "wrapper mb-4",
                onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createCommentVNode(" 상품 요금 시작 금액 "),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${tableLc}order_amount_start`),
                            "is-vertical-label": true,
                            "input-row-class": "",
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _unref(formattedOrderAmountStart),
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (_isRef(formattedOrderAmountStart) ? (formattedOrderAmountStart).value = $event : null)),
                                    variant: "outlined",
                                    density: "compact",
                                    "hide-details": "",
                                    maxlength: _unref(STORE_ORDER_AMOUNT_MAX_LENGTH),
                                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '시작 금액' }),
                                    error: isDuplicatedError.value,
                                    rules: formRules.value.orderAmountStart
                                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder", "error", "rules"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" 상품 요금 종료 금액 "),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${tableLc}order_amount_end`),
                            "is-vertical-label": true,
                            "input-row-class": "",
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_text_field, {
                                    modelValue: _unref(formattedOrderAmountEnd),
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_isRef(formattedOrderAmountEnd) ? (formattedOrderAmountEnd).value = $event : null)),
                                    variant: "outlined",
                                    "hide-details": "",
                                    density: "compact",
                                    maxlength: _unref(STORE_ORDER_AMOUNT_MAX_LENGTH),
                                    oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                    placeholder: _ctx.$t('common.input_field_placeholder', { field: '종료 금액' }),
                                    error: isDuplicatedError.value,
                                    rules: formRules.value.orderAmountEnd
                                }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder", "error", "rules"])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"]),
                        _createCommentVNode(" 할증 금액 (할증 퍼센트) "),
                        _createVNode(InputRow, {
                            label: _ctx.$t(`${tableLc}surcharge`),
                            "is-vertical-label": true,
                            "input-row-class": "",
                            "is-required": ""
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, [
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _unref(formattedSurcharge),
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (_isRef(formattedSurcharge) ? (formattedSurcharge).value = $event : null)),
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "auto",
                                        maxlength: _unref(STORE_SURCHARGE_MAX_LENGTH),
                                        oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                        placeholder: _ctx.$t('common.input_field_placeholder', { field: '할증 금액' }),
                                        suffix: _ctx.$t('common.currency'),
                                        rules: formRules.value.surcharge,
                                        onBlur: _cache[3] || (_cache[3] = ($event) => (onBlurSurchargeField(_unref(formattedSurcharge))))
                                    }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder", "suffix", "rules"]),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _unref(formattedSurchargeRate),
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_isRef(formattedSurchargeRate) ? (formattedSurchargeRate).value = $event : null)),
                                        variant: "outlined",
                                        density: "compact",
                                        "hide-details": "auto",
                                        maxlength: _unref(STORE_SURCHARGE_RATE_MAX_LENGTH),
                                        oninput: "javascript: this.value = this.value.replace(/[^0-9|.]/g, '' );",
                                        placeholder: _ctx.$t('common.input_field_placeholder', { field: '할증 퍼센트' }),
                                        suffix: _ctx.$t('unit.percent'),
                                        rules: formRules.value.surchargeRate,
                                        onBlur: _cache[5] || (_cache[5] = ($event) => (onBlurSurchargeRateField(_unref(formattedSurchargeRate))))
                                    }, null, 8 /* PROPS */, ["modelValue", "maxlength", "placeholder", "suffix", "rules"])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["label"])
                    ]),
                    _createCommentVNode(" Footer "),
                    _createVNode(_component_v_card_actions, { class: "pa-0 mt-4 d-flex justify-end dialog__footer" }, {
                        default: _withCtx(() => [
                            _withDirectives((_openBlock(), _createBlock(_component_v_btn, { onClick: handleClickCancelBtn }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })), [
                                [
                                    _directive_btn_style,
                                    void 0,
                                    "config",
                                    {
                                        info: true,
                                        outlined: true,
                                        "size-l": true,
                                        "width-s": true
                                    }
                                ]
                            ]),
                            _createVNode(_component_v_btn, {
                                class: "brg-btn primary size-l width-s",
                                disabled: isSubmitDisabled.value,
                                type: "submit"
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('common.add')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["disabled"])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])), [
                [_vShow, isAddSurchargeSectionOpen.value]
            ]);
        };
    }
});
